/**
 * Experiment setting for the brand self-serve orders and payments tree expansions
 */
export const BRAND_SELF_SERVE_ORDERS_PAYMENTS_TREE_EXPANSION_240429 = 'BRAND_SELF_SERVE_ORDERS_PAYMENTS_TREE_EXPANSION_240429';
